import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11ef251b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "item text" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "item text" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = { class: "item text" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = ["alt"]
const _hoisted_13 = { class: "item text" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = ["alt"]
const _hoisted_16 = { class: "item text" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = ["alt"]
const _hoisted_19 = { class: "item text" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = ["alt"]
const _hoisted_22 = { class: "item text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_stations_view = _resolveComponent("stations-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasMultiplesApps)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          gutter: 12
        }, {
          default: _withCtx(() => [
            (_ctx.canAccessSupport)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      shadow: "hover",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go('/support/samplingPoints'))),
                      class: "card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("img", {
                            src: "/img/ico01.png",
                            alt: _ctx.$t('app.support'),
                            class: "image"
                          }, null, 8, _hoisted_3)
                        ]),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("app.support")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.canAccessStations)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 1,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      shadow: "hover",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go('/stations/stations'))),
                      class: "card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            src: "/img/ico02.png",
                            alt: _ctx.$t('app.stations'),
                            class: "image"
                          }, null, 8, _hoisted_6)
                        ]),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("app.stations")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.canAccessAdmin)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 2,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      shadow: "hover",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go('/admin/samplingPoints'))),
                      class: "card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("img", {
                            src: "/img/ico03.png",
                            alt: _ctx.$t('app.admin'),
                            class: "image"
                          }, null, 8, _hoisted_9)
                        ]),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("app.admin")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        (_ctx.canAccessProcessTracking)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              md: 8
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "hover",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go('/process-tracking/samplingpoints'))),
                  class: "card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("img", {
                        src: "/img/ico04.png",
                        alt: _ctx.$t('app.process_tracking'),
                        class: "image"
                      }, null, 8, _hoisted_12)
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("app.process_tracking")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.canAccessAdmin)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              md: 8
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "hover",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.go('/sace/saceMap'))),
                  class: "card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: "/img/logo-water.png",
                        alt: _ctx.$t('app.sace'),
                        class: "image"
                      }, null, 8, _hoisted_15)
                    ]),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("app.sace")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.canAccessIssueMonitoring)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 2,
              md: 8
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "hover",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.go('/issue-monitoring/samplingpoints'))),
                  class: "card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("img", {
                        src: "/img/ico05.png",
                        alt: _ctx.$t('app.issue_monitoring'),
                        class: "image"
                      }, null, 8, _hoisted_18)
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("app.issue_monitoring")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        (_ctx.canAccessIssueMonitoring)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              md: 8
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "hover",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.go('/issue-monitoring/data-studio'))),
                  class: "card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("img", {
                        src: "/img/data-studio.png",
                        alt: _ctx.$t('app.data_studio'),
                        class: "image"
                      }, null, 8, _hoisted_21)
                    ]),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("app.data_studio")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.hasMultiplesApps && _ctx.canAccessStations)
      ? (_openBlock(), _createBlock(_component_stations_view, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}